import React, { lazy, Suspense, useEffect, useState } from "react"


// Helper function to assign icon based on name
const assignIcon = (name, icon) => {
  const iconMap = {
    "Concert": 'music',
    "Music": 'music',
    "Arts & Entertainment": 'art',
    "Comedy": 'comedy',
    "Festival": 'festival',
    "Book": 'book',
    "Attractions": 'attractions',
    "Film": 'film',
    "Food": 'food',
    "Services": 'community',
    "Sports & Fitness": 'sports',
    "Wellness": 'health',
  };

  const bestIcon = iconMap[name] || icon
  return bestIcon;
}

const BadgeAction = ({
  badges = [],
  offers = [],
  ...props
}) => {
  const offerFirst = offers && offers.length > 0 ? offers[0] : null
  const offerText = typeof offerFirst === 'string' ? offerFirst : offerFirst?.description

  // TODO: This is a temporary fix until we can get the badges from the API
  const lookup = {
    '207Day2024': {
      name: '207 Day Weekend Scavenger Hunt',
      slug: '207-day-weekend-scavenger-hunt',
      icon: 'https://vibemap.wpengine.com/wp-content/uploads/2024/01/207-Day-Weekend-Scavenger-Hunt.jpg',
      link: 'https://airtable.com/app96MYvA0iiWavHu/pagTwAUdanDcRx3Xi/form',
    },
    "OWW": {
      name: 'Oakland Works Wednesday',
      slug: 'oakland-works-wednesday',
      icon: 'https://vibemap.wpengine.com/wp-content/uploads/2025/01/oww.png',
      link: 'https://www.oaklandcentral.com/oww',
      link_name: 'Learn More'
    },
    'Springfield_Coffee_Trail': {
      name: 'Springfield Coffee Trail',
      slug: 'springfield-coffee-trail',
      icon: 'https://res.cloudinary.com/bandwango/image/upload/c_crop,h_640,w_1280,x_0,y_0/w_600,f_auto,q_auto/v1/partners/deal/5183/ndx3pq8hfkaad6my6tth',
      link: 'https://www.springfieldmo.org/ozarks-coffee-trail/',
    },
  }

  const lookupKeys = Object.keys(lookup)

  const iconStyle = {
    borderRadius: '50%',
    float: 'left',
    width: '6rem',
    height: '6rem',
    margin: '1rem',
    marginRight: '2rem',
  }

  const specialStyle = {
    color: '#006400',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  }

  const items = badges && Array.isArray(badges) && badges.length > 0
    ? badges.map(badgeName => {
      const badge = lookup[badgeName];

      return badge
        ? (
          <div className="badge" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: '0 0 auto' }}>
              <img src={badge.icon} alt={badge.name} style={iconStyle} />
            </div>
            <div style={{ flex: '1 1 auto' }}>
              <p>This place is part of the <strong className="badge__name">{badge.name}</strong></p>
              {offerText ? <p style={specialStyle}>🏷️ {offerText}</p> : null}
            </div>
          </div>
        )
        : null

    })
    : null

  let parsedBadges = badges;

  // Check if badges is a string and parse it
  if (typeof badges === 'string') {
    try {
      parsedBadges = JSON.parse(badges);
    } catch (error) {
      console.error('Failed to parse badges:', error);
      parsedBadges = [];
    }
  }

  const showAction = parsedBadges.length > 0 && parsedBadges.some(badge => lookupKeys.includes(badge))

  const style = {
    display: showAction ? 'block' : 'none',
    boxShadow: '0 0 0 1px rgba(34,36,38,.15) inset, 0 0 0 0 transparent',
    borderRadius: '.28571429rem',
    margin: '2rem 0',
    padding: '1rem',
  }

  const badgeCurrent = lookup[parsedBadges[0]]
  const link = `/badges/${badges[0].slug}`
  const className = `ui button small ${showAction ? 'active' : ''}`
  const actionLink = showAction ? badgeCurrent && badgeCurrent?.link : null
  const actionLinkName = badgeCurrent?.link_name || 'Check In'

  return (
    <div className='badge' style={style}>
      {items}
      <a className={className} href={actionLink} target='_blank'>
        {actionLinkName}
      </a>
    </div>
  )
}


export default BadgeAction